import { atom } from "jotai";
import { DataSchema } from "common";

export const bookmarksAtom = atom<DataSchema.Bookmark[]>([]);
